module.exports = __webpack_public_path__ + "media/images/front/doctor-noimage-ebd924d232df73c550be9b1dfc53c62c.png";